const features = [
  {
    icon: 'ri-map-pin-2-line',
    color: 'text-green-600',
    bg: 'bg-green-50',
    title: 'Real-Time Tracking',
    desc: 'See exactly where every cleaner is. Live GPS updates keep dispatchers and customers in sync.',
  },
  {
    icon: 'ri-calendar-check-line',
    color: 'text-sky-500',
    bg: 'bg-sky-50',
    title: 'Smart Scheduling',
    desc: 'AI-powered dispatch assigns the right team to the right job based on skill, location & availability.',
  },
  {
    icon: 'ri-chat-3-line',
    color: 'text-teal-500',
    bg: 'bg-teal-50',
    title: 'Instant Messaging',
    desc: 'Built-in team chat and customer notifications. Everyone stays in the loop, always.',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    color: 'text-emerald-500',
    bg: 'bg-emerald-50',
    title: 'Powerful Analytics',
    desc: 'Track completion rates, team performance, revenue trends and more — all in one dashboard.',
  },
  {
    icon: 'ri-file-text-line',
    color: 'text-amber-500',
    bg: 'bg-amber-50',
    title: 'Digital Work Orders',
    desc: 'Create, assign and close jobs paperlessly. Customers sign off digitally in seconds.',
  },
  {
    icon: 'ri-shield-check-line',
    color: 'text-green-700',
    bg: 'bg-green-100',
    title: 'Enterprise Security',
    desc: 'SOC 2 Type II certified. Role-based access controls, audit logs and data encryption.',
  },
];

export default function FeaturesSection() {
  return (
    <section className="px-5 py-10 bg-white">
      <div className="text-center mb-8">
        <span className="inline-block bg-green-50 text-green-600 text-[10px] font-bold tracking-wide px-3 py-1 rounded-full border border-green-100 mb-3">
          Why finfins
        </span>
        <h2 className="text-gray-800 font-bold text-2xl leading-tight">
          Everything You Need<br />In One Platform
        </h2>
        <p className="text-gray-400 text-sm mt-2">
          Trusted by eco cleaning companies across residential, commercial and industrial sectors.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {features.map((f) => (
          <div key={f.title} className="bg-[#f8f9fa] rounded-xl p-4 border border-gray-100">
            <div className={`w-9 h-9 rounded-lg ${f.bg} flex items-center justify-center mb-3`}>
              <i className={`${f.icon} ${f.color} text-lg`}></i>
            </div>
            <div className="text-gray-800 font-semibold text-xs mb-1.5 leading-snug">{f.title}</div>
            <div className="text-gray-400 text-[11px] leading-relaxed">{f.desc}</div>
          </div>
        ))}
      </div>

      {/* Social proof strip */}
      <div className="mt-8 bg-green-600 rounded-2xl p-5 text-center">
        <div className="text-white font-bold text-lg mb-1">Save 6+ hours/week</div>
        <div className="text-green-100 text-xs leading-relaxed">
          Teams using finfins reduce admin time by 65% and increase job completion by 40% in the first 30 days.
        </div>
      </div>
    </section>
  );
}
